// src/features/devices/history/thunkRedo.ts
import { createAsyncThunk } from "@reduxjs/toolkit";

import { openapi } from "../../../openapi";
import { IRootState, AppDispatch } from "../../app/store";
import { withWorldZInCoordinate } from "../devices/deviceUtils";
import {
  popRedoToUndoInRedux,
  popUndoToRedoInRedux,
  selectTopRedoCommand,
  setIsApplyingHistoryInRedux,
} from "./deviceHistorySlice";

export const thunkRedo = createAsyncThunk<void, void, { state: IRootState; dispatch: AppDispatch }>(
  "deviceHistory/redo",
  async (_, { getState, dispatch }) => {
    const state = getState();
    const cmd = selectTopRedoCommand(state);
    if (!cmd) return;

    // Vi må flytte cmd redo -> undo før vi applier (for symmetri med undo)
    dispatch(popRedoToUndoInRedux());
    dispatch(setIsApplyingHistoryInRedux(true));

    try {
      const floorElevationM = state.design.floorAndJob?.elevation;
      if (cmd.after._id == null) {
        return;
      }
      const device = {
        ...cmd.after,
        _id: String(cmd.after._id),
        coordinate: withWorldZInCoordinate(
          cmd.after.coordinate,
          floorElevationM,
          cmd.after.bottomEdgeHeightAboveFloorMm
        ),
      };
      await dispatch(
        openapi.endpoints.putMultiplacerDeviceUpdate.initiate({
          body: { device },
        })
      ).unwrap();
    } catch (e) {
      // Rollback stack ved feil: undo -> redo
      dispatch(popUndoToRedoInRedux());
      throw e;
    } finally {
      dispatch(setIsApplyingHistoryInRedux(false));
    }
  }
);
